export default "__VITE_ASSET__325adcaf__"